import React from "react";
import CircularProgress from "material-ui/CircularProgress";
import style from "./style";
import { colors } from "assets";

const backgroundStyle = loading =>
  loading
    ? { display: "block", opacity: "1" }
    : { display: "none", opacity: "0" };

const customSizeStyle = customSize => (customSize ? customSize : 50);

const customThicknessStyle = customThickness =>
  customThickness ? customThickness : 5;

const Loadable = ({
  children,
  className,
  loading,
  customSize,
  customThickness
}) => (
  <div className={className}>
    {children}

    <div className="background" style={backgroundStyle(loading)}>
      <div className="loader">
        <CircularProgress
          size={customSizeStyle(customSize)}
          thickness={customThicknessStyle(customThickness)}
          color={colors.primary.normal}
        />
      </div>
    </div>
  </div>
);

Loadable.defaultProps = {
  loading: false,
  dark: false,
  size: 80,
  thickness: 5
};

export default style(Loadable);



// WEBPACK FOOTER //
// ./src/components/support/loadable/index.jsx